module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp12_8003.5b0c8d8b.png";